/** MapLibre source / layer id sözleşmesi. */

export const GTFS_MAP_SOURCES = {
  stops: 'ge-stops',
  routeLines: 'ge-route-lines',
  populationPoints: 'ge-population-points',
  /** Base — kalıcı idari sınırlar (paylaşılan) */
  baseIlce: 'ge-base-ilce',
  baseMahalle: 'ge-base-mahalle',
  isochrones: 'ge-isochrones',
  isochroneCoverage: 'ge-isochrone-coverage',
  isochroneAdmin: 'ge-isochrone-admin',
  catchmentIso: 'ge-catchment-iso',
  catchmentCoverage: 'ge-catchment-coverage',
  catchmentAdmin: 'ge-catchment-admin',
  corridorLine: 'ge-corridor-line',
  corridorArea: 'ge-corridor-area',
  saBuffers: 'ge-sa-buffers',
  saCoverage: 'ge-sa-coverage',
  saStops: 'ge-sa-stops',
  transitDesert: 'ge-transit-desert',
  adminMahalle: 'ge-admin-mahalle',
  adminIlce: 'ge-admin-ilce',
  /** Interaction */
  selectedFeature: 'ge-selected-feature',
  hoverFeature: 'ge-hover-feature',
}

/** Layer Manager kategori / owner metadata */
export const LAYER_OWNERS = Object.freeze({
  shared: 'shared',
  isochrone: 'isochrone',
  catchment: 'catchment',
  corridor: 'corridor',
  serviceAvailability: 'service-availability',
  transitDesert: 'transit-desert',
})

export const LAYER_CATEGORIES = Object.freeze({
  base: 'base',
  analysis: 'analysis',
  reference: 'reference',
  interaction: 'interaction',
})

export const GTFS_MAP_LAYERS = {
  stopsCircle: 'ge-stops-circle',
  stopsSelected: 'ge-stops-selected',
  stopsHit: 'ge-stops-hit',
  stopsLabel: 'ge-stops-label',
  /** Ağ özeti — tüm hatlar kendi renginde */
  routeLine0: 'ge-route-line-0',
  /** Seçili hat — kalın, yön ofsetli */
  routeLine1: 'ge-route-line-1',
  routeCasing: 'ge-route-casing',
  routeArrows: 'ge-route-arrows',
  routeLabel: 'ge-route-label',
  routeHit: 'ge-route-hit',
  populationCircle: 'ge-population-circle',
  baseIlceFill: 'ge-base-ilce-fill',
  baseIlceLine: 'ge-base-ilce-line',
  baseMahalleFill: 'ge-base-mahalle-fill',
  baseMahalleLine: 'ge-base-mahalle-line',
  isochroneFill: 'ge-isochrone-fill',
  isochroneLine: 'ge-isochrone-line',
  isochroneCoverageFill: 'ge-isochrone-coverage-fill',
  isochroneCoverageLine: 'ge-isochrone-coverage-line',
  isochroneAdminFill: 'ge-isochrone-admin-fill',
  isochroneAdminLine: 'ge-isochrone-admin-line',
  catchmentFill: 'ge-catchment-fill',
  catchmentCoverageFill: 'ge-catchment-coverage-fill',
  catchmentCoverageLine: 'ge-catchment-coverage-line',
  catchmentAdminFill: 'ge-catchment-admin-fill',
  catchmentAdminLine: 'ge-catchment-admin-line',
  corridorLine: 'ge-corridor-line',
  corridorHit: 'ge-corridor-hit',
  corridorAreaFill: 'ge-corridor-area-fill',
  corridorAreaLine: 'ge-corridor-area-line',
  /** z-order: sparse alttan frequent üste — ayrı fill katmanları (Detail) */
  saBufferNoService: 'ge-sa-buf-no-service',
  saBufferSparse: 'ge-sa-buf-sparse',
  saBufferLimited: 'ge-sa-buf-limited',
  saBufferRegular: 'ge-sa-buf-regular',
  saBufferFrequent: 'ge-sa-buf-frequent',
  saCoverageFill: 'ge-sa-coverage-fill',
  saCoverageLine: 'ge-sa-coverage-line',
  saStopsCircle: 'ge-sa-stops-circle',
  saStopsHit: 'ge-sa-stops-hit',
  transitDesertFill: 'ge-transit-desert-fill',
  transitDesertLine: 'ge-transit-desert-line',
  adminMahalleFill: 'ge-admin-mahalle-fill',
  adminMahalleLine: 'ge-admin-mahalle-line',
  adminMahalleLabel: 'ge-admin-mahalle-label',
  adminIlceFill: 'ge-admin-ilce-fill',
  adminIlceLine: 'ge-admin-ilce-line',
  adminIlceLabel: 'ge-admin-ilce-label',
  selectedFeatureLine: 'ge-selected-feature-line',
  selectedFeatureFill: 'ge-selected-feature-fill',
  hoverFeatureLine: 'ge-hover-feature-line',
}

export const STOP_LAYER_IDS = Object.freeze([
  GTFS_MAP_LAYERS.stopsHit,
  GTFS_MAP_LAYERS.stopsSelected,
  GTFS_MAP_LAYERS.stopsCircle,
  GTFS_MAP_LAYERS.stopsLabel,
])

export const ROUTE_LAYER_IDS = Object.freeze([
  GTFS_MAP_LAYERS.routeLine0,
  GTFS_MAP_LAYERS.routeCasing,
  GTFS_MAP_LAYERS.routeLine1,
  GTFS_MAP_LAYERS.routeArrows,
  GTFS_MAP_LAYERS.routeLabel,
  GTFS_MAP_LAYERS.routeHit,
])

export const ROUTE_ARROW_IMAGE = 'ge-route-arrow'

export const SA_BUFFER_LAYER_BY_CATEGORY = {
  no_service: GTFS_MAP_LAYERS.saBufferNoService,
  sparse: GTFS_MAP_LAYERS.saBufferSparse,
  limited: GTFS_MAP_LAYERS.saBufferLimited,
  regular: GTFS_MAP_LAYERS.saBufferRegular,
  frequent: GTFS_MAP_LAYERS.saBufferFrequent,
}

/** Mahalle hizmet seviyesi — sequential mavi + no-service kırmızı */
export const ADMIN_CATEGORY_FILL = [
  'match',
  ['get', 'best_category'],
  'frequent',
  '#1d4ed8',
  'regular',
  '#3b82f6',
  'limited',
  '#93c5fd',
  'sparse',
  '#dbeafe',
  'no_service',
  '#dc2626',
  'uncovered',
  '#dc2626',
  '#dbeafe',
]

export const EMPTY_FC = Object.freeze({
  type: 'FeatureCollection',
  features: [],
})

export const MAX_SHAPE_VERTICES = 400
/** Douglas-Peucker toleransı (derece, ~1 m) — köşeleri korur, gereksiz noktaları atar */
export const SHAPE_SIMPLIFY_TOLERANCE = 0.00001
/** geojson-vt zoom bazlı sadeleştirme toleransı (piksel) */
export const ROUTE_SOURCE_TOLERANCE = 0.45
export const VIEWPORT_STOP_BUDGET = 4000
export const MOVEEND_DEBOUNCE_MS = 80

/** OW navy/teal paleti — izokron süre basamakları (eski tek-renk sıra) */
export const ISOCHRONE_COLORS = ['#0f3d5c', '#1a6b7a', '#2a9d8f', '#48b5a8']

/** Profil bazlı renkler — çoklu katman karşılaştırması */
export const ISOCHRONE_PROFILE_COLORS = {
  walk: '#0d9488',
  transit: '#0f3d5c',
  drive: '#c2410c',
}

export const ISOCHRONE_MINUTE_OPTIONS = [10, 20, 30, 45]
export const ISOCHRONE_PROFILE_OPTIONS = [
  { id: 'walk', label: 'Yürüme' },
  { id: 'transit', label: 'Toplu taşıma' },
  { id: 'drive', label: 'Otomobil' },
]

/** MapLibre match ifadesi — fill/line rengi */
export const ISOCHRONE_FILL_COLOR_EXPR = [
  'match',
  ['get', 'profile'],
  'walk',
  ISOCHRONE_PROFILE_COLORS.walk,
  'drive',
  ISOCHRONE_PROFILE_COLORS.drive,
  'transit',
  ISOCHRONE_PROFILE_COLORS.transit,
  '#1a6b7a',
]

export const ISOCHRONE_FILL_OPACITY_EXPR = [
  'interpolate',
  ['linear'],
  ['to-number', ['get', 'minutes']],
  5,
  0.42,
  10,
  0.34,
  20,
  0.24,
  30,
  0.16,
  45,
  0.11,
  60,
  0.08,
]
